import { Alert, Row } from "antd";
import CommunicationList from "../CommunicationList";
import AdminCommunicationList from "../CommunicationList/AdminCommunicationList";

type EmailTemplatesPanelProps = {
  mode: "tenant" | "admin";
  groupId: string;
  communicationDocuments: any[];
};

const EmailTemplatesPanel: React.FC<EmailTemplatesPanelProps> = ({
  mode,
  groupId,
  communicationDocuments,
}) => (
  <>
    <Alert
      type="info"
      showIcon
      message="Email templates"
      description="HTML templates used for email communications. Create and edit templates here; they are sent when email notification is enabled."
      style={{ marginBottom: 16 }}
    />
    <Row gutter={[12, 12]} className="document-container">
      {mode === "admin" ? (
        <AdminCommunicationList
          groupId={groupId}
          documents={communicationDocuments}
        />
      ) : (
        <CommunicationList
          groupId={groupId}
          documents={communicationDocuments}
        />
      )}
    </Row>
  </>
);

export default EmailTemplatesPanel;
